class QueryParamsHelper {
  private loadSearchParams(): Record<string, string> {
    if (typeof window === 'undefined') {
      return {};
    }

    return Object.fromEntries(new URLSearchParams(window.location.search).entries());
  }

  private loadHashParams(): Record<string, string> {
    if (typeof window === 'undefined' || !window.location.hash.startsWith('#?')) {
      return {};
    }

    return Object.fromEntries(new URLSearchParams(window.location.hash.slice(1)).entries());
  }

  private loadUrlParams(): Record<string, string> {
    return {
      ...this.loadSearchParams(),
      ...this.loadHashParams(),
    };
  }

  private loadParams(): Record<string, string> {
    const urlParams = this.loadUrlParams();

    try {
      const stored = sessionStorage.getItem('queryParamsForBolt');
      if (stored) {
        return {
          ...JSON.parse(stored),
          ...urlParams,
        };
      }
    } catch {
      // Ignore error
    }

    return urlParams;
  }

  get(key: string): string | null {
    const params = this.loadParams();
    return params[key] || null;
  }

  has(key: string): boolean {
    const params = this.loadParams();
    return key in params;
  }

  getAll(): Record<string, string> {
    return { ...this.loadParams() };
  }

  set(key: string, value: string): void {
    const params = this.loadParams();
    params[key] = value;
    this.save(params);
  }

  delete(key: string): void {
    const params = this.loadParams();
    delete params[key];
    this.save(params);
  }

  clear(): void {
    sessionStorage.removeItem('queryParamsForBolt');
  }

  private save(params: Record<string, string>): void {
    try {
      sessionStorage.setItem('queryParamsForBolt', JSON.stringify(params));
    } catch {
      // Ignore error
    }
  }
}

export const queryParams = new QueryParamsHelper();
